export enum PreferredContactMethodEnum {
    Any = 1,
    Email = 2,
    Phone = 3,
    SMS = 4,
    Mail = 5
}

export enum PrimaryContactLanguageEnum {
    Swedish = 805250000,
    English = 805250001
}

export enum OccupationEnum {
    Employee = 805250000,
    SelfEmployed = 805250001,
    Student = 805250002,
    Pensioner = 805250003,
    Other = 805250004
}

export enum StatusEnum {
    Active = 0,
    Inactive = 1
}

export enum MemberCategoryEnum {
    HonoraryMember = 805250000,
    AnnualMember = 805250001,
    PermanentMember = 805250002,
    SupportMember = 805250003
}

export enum MembershipStatusReasonEnum {
    Active = 1,
    DeniedEntry = 2,
    OngoingEntry  = 805250000,
    Finished = 805250001,
    LackOfPayment = 805250002,
    OwnRequest = 805250003,
    Suspended = 805250004
}

export enum OrganisationCategoryEnum {
    Selectable  = 805250000,
    Closed = 805250001,
    RequiresApplication = 805250002,
    NotSelectable = 805250003,
    Hidden = 805250004
}
